<template>
<div class="ma-auto">
  <vue-headful :title="'Учебные планы'"/>
  <v-layout style="max-width: 100%;" class="align-center pb-4">
    <v-breadcrumbs class="pa-0" :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-spacer></v-spacer>
    <v-text-field
        @blur="saveFilter"
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        label="Поиск"
        single-line
        hide-details
        solo
        class="search-field"
        clearable
    ></v-text-field>
  </v-layout>
  <v-card>
    <v-data-table :loading="loading" :page.sync="page" @update:page="savePage" :search="search" :items="plans" :headers="headers" :items-per-page="15">
      <template v-slot:item.fileName="{ item }">
        <v-layout>
          <v-icon left>mdi-link</v-icon>
          <a :href='`#/Plans/${item.planID}`'>
            {{item.fileName}}
          </a>
        </v-layout>

      </template>
    </v-data-table>
  </v-card>

</div>
</template>

<script>
import plans from "@/helpers/api/plans";
export default {
  name: "PlansList",
  data () {
    return {
      plans: [],
      search: null,
      page: 1,
      loading: true
    }
  },
  computed: {
    breadcrumbs () {
      return [
        { text: 'Учебные планы', disabled: true }
      ]
    },
    headers () {
      return [
          {text: 'Имя файла', value: 'fileName'},
          {text: 'Специальность', value: 'titul'},
          {text: 'Скан-копия', value: 'scan'},
      ]
    }
  },
  mounted() {

    this.load()
  },
  methods: {
    savePage(e) {
      sessionStorage.setItem('plansListPage', e)
    },
    saveFilter() {
      if(this.search) {
        sessionStorage.setItem('plansListFilter', this.search)
      } else {
        sessionStorage.setItem('plansListFilter', '')
      }
    },
    async load () {
      this.loading = true
      this.plans = await plans.getPlans()
      this.loading = false

      if(sessionStorage.getItem('plansListPage')) {
        this.page = Number(sessionStorage.getItem('plansListPage'))
      }
      if(sessionStorage.getItem('plansListFilter')) {
        this.search = sessionStorage.getItem('plansListFilter')
      }
    }
  }
}
</script>

<style scoped>

</style>
